"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var clearSavedLocalData = function clearSavedLocalData(label) {
  // Remove the object in storage
  localStorage.removeItem(label);
};

exports.default = clearSavedLocalData;